module.exports = function getResource(label, vars = []) {
    let resources = {
        termsOfUseLink: 'Terms of Use',
        privacyPolicyLink: 'Privacy Policy',
        privacyPolicyTitle: 'Privacy Policy',
        termsOfUseTitle: 'Sephora Terms of Use'
    };

    return resources[label];
};
